"use client";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Link from 'next/link'
import DynamicImage from "../DynamicImages/DynamicImage";
import CardImage1 from "@/assets/images/static/leapIntoLuxury/sp-01.png";
import CardImage2 from "@/assets/images/static/leapIntoLuxury/sp-02.png";
import CardImage3 from "@/assets/images/static/leapIntoLuxury/sp-03.png";
import CardImage4 from "@/assets/images/static/leapIntoLuxury/sp-04.png";
import CardImage5 from "@/assets/images/static/leapIntoLuxury/sp-05.png";
import CardImage6 from "@/assets/images/static/leapIntoLuxury/sp-06.png";
import { useState, useEffect } from "react";

const Card = ({ src, text1, text2 }) => {
  return (
    <div className="p-[15px] h-full flex items-end">
      <div className=" h-full hover:shadow-UnCompromisingCard flex flex-col p-[15px] rounded-10 justify-end items-center w-full gap-[25px]">
        <DynamicImage className="max-w-[92px] mob:max-w-[140px]  " src={src} alt="image" />
        <div className=" text-[13px] text-[#000] text-center leading-[16px] font-light ">
          <p className="underline">{text1}</p>
          <p className="underline">{text2}</p>
        </div>
      </div>
    </div>
  );
};

const ProductData = [
  {
    src: CardImage1,
    text1: "36” Masterpiece(R)",
    text2: " Gas Cooktop",
    link: "/thermador-gas-cooktop-36-stainless-steel-sgsx365ts"
  },
  {
    src: CardImage2,
    text1: "30” Pro Harmony(R)",
    text2: " Gas Professional Range",
    link: "/thermador-gas-professional-range-30-pro-harmony-r-standard-depth-stainless-steel-prg305wh"
  },
  {
    src: CardImage3,
    text1: "30” Masterpiece(R) Single",
    text2: " Wall Oven",
    link: "/thermador-masterpiece-r-single-wall-oven-30-stainless-steel-me301yp"
  },
  {
    src: CardImage4,
    text1: "36” Masterpiece(R) ",
    text2: "Freestanding French Door Refrigerator",
    link: ""
  },
  {
    src: CardImage5,
    text1: "36” Freedom(R)",
    text2: "Freestading French Door Refrigerator ",
    link: "/thermador-freedom-r-french-door-bottom-mount-refrigerator-36-stainless-steel-t36ft820ns"
  },
  {
    src: CardImage6,
    text1: "30” Masterpiece(R) ",
    text2: " Double Gas Cooktop",
    link: "/thermador-masterpiece-r-masterpiece-r-double-wall-oven-30-stainless-steel-me302yp"
  },
];

const UnCompromising = () => {
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) return;

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };
  return (
    <div className="mb-[80px] mob:mb-0">
      <div className=" text-center bg-[#F8F8F8] ">
        <h2 className=" leading-[48px] text-[36px]   text-[#242222] py-[40px] lg:text-[30px] lg:leading-[45px] mob:max-w-[370px] mob:mx-auto">
          Featured Leap Into Luxury Products
        </h2>
      </div>
      <div className="bg-[#F8F8F8] mob:pb-[24px]">
        <div className=" max-w-[1352px] my-0 mx-auto px-[15px] mob:hidden">
          <Carousel
            opts={{
              align: "start",
            }}
            className="w-full pb-[15px] "
            setApi={setApi}
          >
            <CarouselContent className="m-0">
              {ProductData.map((product, index) => (
                <CarouselItem
                  key={index}
                  className="basis-1/4 mlg:basis-1/3 slg:basis-5/12 md:basis-1/2 sm:basis-8/12 mob:basis-full m-0"
                >
                  <Link href={product.link} passHref>
                    <Card
                      src={product.src}
                      text1={product.text1}
                      text2={product.text2}
                    />
                  </Link>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className=" grid grid-cols-[1fr_auto] lg:grid-cols-[1fr_auto] items-center gap-3 lg:pl-2">
              {/* Clickable Pagination Dots */}
              <div className="flex justify-center ">
                {Array.from({ length: count }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-full h-1  transition-all ${
                      current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                    }`}
                  />
                ))}
              </div>
              {/* Navigation Buttons */}
              <div className="flex items-center justify-end gap-3">
                <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
                <div className="text-sm text-[#0C2340] font-medium">
                  {current}/{count}
                </div>
                <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
              </div>
            </div>
            {/* } */}
          </Carousel>
        </div>
        <div className="mob:grid hidden">
        {ProductData.map((product, index) => (
                <div
                  key={index}
                  className="basis-1/4 mlg:basis-1/3 slg:basis-5/12 md:basis-1/2 sm:basis-8/12 mob:basis-full m-0"
                >
                  <Link href={product.link} passHref>
                    <Card
                      src={product.src}
                      text1={product.text1}
                      text2={product.text2}
                    />
                  </Link>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default UnCompromising;